import { css } from "../../../component-styles";

export const uiBear = css`
  .brand-nav-title {
    margin: 0;
    display: inline-block;
  }
  .brand-nav-title-text {
    display: inline-block;
  }
  .hero-title {
    margin: 0 0 20px;
  }
  .brand-footer-powered {
    color: #444;
  }
`;
